import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';

import './App.css';
import history from './history';
import { StartQuestionnaireContainer } from './components/startQuestionnaire/StartQuestionnaireContainer';
import { QuestionnaireContainer } from './components/questionnaire/QuestionnaireContainer';
import { QuestionnaireCompletedContainer } from './components/questionnaireCompleted/QuestionnaireCompletedContainer';
import { SubmitQuestionnaireContainer } from './components/submitQuestionnaire/SubmitQuestionnaireContainer';
import { TestResultContainer } from './components/testResult/TestResultContainer';
import ErrorPage from './components/error';
import NotFoundPage from './components/notFound';

class App extends Component {
  render() {
    return (
      <Grid fluid style={{ marginBottom: '5vh' }}>
        <Row>
          <Col xs={10} xsOffset={1} sm={10} smOffset={1} md={10} mdOffset={1} lg={10} lgOffset={1}>
            <Router history={history}>
              <Switch>
                <Route exact path='/' component={StartQuestionnaireContainer} />
                <Route path='/questionnaire' component={QuestionnaireContainer} />
                <Route path='/submit' component={SubmitQuestionnaireContainer} />
                <Route path='/complete' component={QuestionnaireCompletedContainer} />
                <Route path='/test-result' component={TestResultContainer} />
                <Route path='/error' component={ErrorPage} />
                <Route path='*' component={NotFoundPage} />
              </Switch>
            </Router>
          </Col>
        </Row>
      </Grid>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js